import script from "./AssessmentGovernancePlanning.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernancePlanning.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernancePlanning.vue?vue&type=style&index=0&id=042d4a71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042d4a71"]])

export default __exports__